import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [welcomeVisible, setWelcomeVisible] = useState(true);
  const chatBoxRef = useRef(null);
  const latestMessageRef = useRef(null);

  useEffect(() => {
    if (latestMessageRef.current) {
      latestMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatHistory]);

  const sendMessage = async () => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const userInput = message.trim();
    if (!userInput) return;

    setChatHistory((prevChatHistory) => [
      ...prevChatHistory,
      { sender: 'Jij', content: userInput },
    ]);
    setMessage('');
    setWelcomeVisible(false);

    const res = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: [
          { role: 'system', content: 'No Yapping. Je bent een behulpzame AI-assistent. En geeft alleen relevante informatie en bent kort en bondig. Als je een link deelt, dan mag je nooit een . plaatsen aan het einde van de link, gebruik alleen de originele link. Gebruik de informatie die ik aan je geef. Als je geen antwoord hebt, dan laat je weten dat je het niet weet. Gebruik deze standaardinformatie voor je antwoorden: - Als er wordt gevraagd naar de spreker, dan gaat het om: Robbert van Empel - Alleen als er wordt gevraagd om een emailadres: hallo@robbertvanempel.nl - Als er wordt gevraagd wat Robbert voor werk doet: Robbert spreekt over AI, waarin hij mensen inspireert om te werken met AI. - Als er wordt gevraagd naar de werkwijze van Robbert: Robbert laat zien welke kansen en gevaren AI heeft en zorgt ervoor dat mensen het belang inzien van het gebruik van AI. - Als er specifiek wordt gevraagd of Robbert workshops kan geven: Robbert kan ook workshops organiseren, bijvoorbeeld in het gebruik van ChatGPT, hoe je goede prompts schrijft, maar ook in het aanraden van de beste tools voor jouw sector. - Als er wordt gevraagd naar de website van Robbert: https://www.robbertvanempel.nl - Als er wordt gevraagd wat de ervaring is van Robbert: Robbert heeft voor groepen van 2000 mensen gesproken en heeft grote studiedagen geleid - Als er wordt gevraagd waar Robbert heeft gesproken: Robbert heeft op de Jaarbeurs gesproken, bij The Next Student, bij stichting Fioretti Teylingen en nog veel meer organisaties. - Als er naar andere ervaringen wordt gevraagd, over wat voor werk Robbert nog meer doet: Robbert is docent, waardoor hij precies weet hoe je de informatie over moet dragen, ook is Robbert onderzoekers voor een AI onderzoeksgroep, waardoor hij precies up to date is over de laatste ontwikkelingen. - Als er wordt gevraagd hoe je contact kunt opnemen met Robbert: Men kan het beste een gesprek inplannen via https://calendly.com/robbertvanempel/ai-spreker-workshop - Als er over het privéleven van Robbert wordt gevraagd: Robbert heeft een vrouw en twee schattige kleine kinderen. - Als er wordt gevraagd waar Robbert woont: Robbert woont in Haarlem. Hij woont daar naast de mooie Koepelkathedraal. - Als er wordt gevraagd naar de kosten: Afhankelijk van de vraag wordt een prijs opgesteld. Robbert rekent prijzen tussen de 400 en 1000 euro.' },
          { role: 'user', content: userInput },
        ],
      }),
    });

    const data = await res.json();
    const assistantMessage = data.choices[0].message.content.trim();
    const formattedMessage = formatMessageWithLinks(assistantMessage);

    setChatHistory((prevChatHistory) => [
      ...prevChatHistory,
      { sender: 'Robbotje', content: formattedMessage },
    ]);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      sendMessage();
    }
  };

  const formatMessageWithLinks = (message) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g;
    return message
      .replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`)
      .replace(emailRegex, (email) => `<a href="mailto:${email}">${email}</a>`);
  };

  return (
    <div className="App">
      <div id="chat-container">
        {welcomeVisible && (
          <div id="welcome-message">
            <img src="welkom.png" alt="Welkom" id="welcome-image" />
            <h1>Robbotje</h1>
            <p>De AI assistent van Robbert!</p>
          </div>
        )}
        <div id="chat-box" ref={chatBoxRef}>
          {chatHistory.map((msg, index) => (
            <div
              key={index}
              className={`chat-message ${msg.sender === 'Jij' ? 'user-message' : 'assistant-message'}`}
              ref={index === chatHistory.length - 1 ? latestMessageRef : null}
            >
              <strong>{msg.sender}:</strong> <span dangerouslySetInnerHTML={{ __html: msg.content }} />
            </div>
          ))}
        </div>
        <div id="input-container">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Typ je vraag hier"
          />
          <button onClick={sendMessage}>Verstuur</button>
        </div>
      </div>
    </div>
  );
}

export default App;
